<script>
import { mapGetters } from '../store'

export default {
    name: 'Footer',
    components: {},
    computed: {
        ...mapGetters(['userResource']),
        
    },
    watch: {
        
    },
    data() {
        return {
            loading: false,
            mailToHref: 'javascript:{}'
        }
    },
    methods: {
        
    },
    async mounted() {
        
    },
}
</script>

<template>
    <footer>
        <b-container>
            <b-row>
                <b-col class="d-none d-sm-block">
                    <b-navbar-brand class="logo-text"><router-link :to="{ name: 'home' }">Node<strong>Jobs</strong></router-link></b-navbar-brand>
                    <p class="mt-3">Find the right tech stack that fits your skillset / Hire the most talented developers.</p>
                    <ul class="list-unstyled">
                        <li><router-link :to="{ name: 'terms' }">Terms of Service</router-link></li>
                    </ul>
                </b-col>
                
                <b-col>
                    <h4>Quick Links</h4>
                    <ul class="list-unstyled">
                        <li><router-link :to="{ name: 'home' }">Home</router-link></li>
                        <li><router-link :to="{ name: 'signupDeveloper' }">Create a Developer Profile</router-link></li>
                        <li><router-link :to="{ name: 'signupCompany' }">Hire Developers</router-link></li>
                        <li><router-link :to="{ name: 'alsoHome', params: { seoSlug: 'san-francisco-js-jobs' }, hash: '#' + JSON.stringify({ regions__in: 'cb758b25-5311-4833-8fe3-9aac1f0fd7a0', search: 'JavaScript' }) }">San Francisco JavaScript Jobs</router-link></li>
                        <li><router-link :to="{ name: 'alsoHome', params: { seoSlug: 'los-angeles-js-jobs' }, hash: '#' + JSON.stringify({ regions__in: 'ea0dc9af-336a-445b-ae25-987570455bbe', search: 'JavaScript' }) }">Los Angeles JavaScript Jobs</router-link></li>
                        <li><router-link :to="{ name: 'alsoHome', params: { seoSlug: 'remote-jobs' }, hash: '#' + JSON.stringify({ remote_level__gte: 3 }) }">Remote Jobs</router-link></li>
                        <li><router-link :to="{ name: 'alsoHome', params: { seoSlug: 'react-js-jobs' }, hash: '#' + JSON.stringify({ search: 'React' }) }">React.js Jobs</router-link></li>
                        <li><router-link :to="{ name: 'alsoHome', params: { seoSlug: 'vue-js-jobs' }, hash: '#' + JSON.stringify({ search: 'Vue' }) }">Vue.js Jobs</router-link></li>
                    </ul>
                </b-col>

                <b-col>
                    <h4>Contact Us</h4>
                    <b-row>
                        <b-col sm="1">
                            <b-icon icon="envelope" />
                        </b-col>
                        <b-col>
                            <a :href="mailToHref" @mousedown="mailToHref = 'mailto:info@nodejobs.net'">&#105;&#110;&#102;&#111;&#064;&#110;&#111;&#100;&#101;&#106;&#111;&#098;&#115;&#046;&#110;&#101;&#116;</a>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="1">
                            <b-icon icon="geo-alt-fill" />
                        </b-col>
                        <b-col>
                            1160 Battery St.<br />
                            Suite 100<br />
                            San Francisco, CA 94111
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>

        <div class="bottom-text">
            <b-container>
                &copy; {{ new Date().getFullYear() }} NodeJobs LLC, All Rights Reserved
            </b-container>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
footer {
    position: relative;
    background-color: #211b31;
    color: #abadbe;
    padding-top: 50px;
    padding-bottom: 5rem;
    min-height: 300px;
    font-weight: bold;

    a {
        color: #abadbe;

        &:hover {
            color: #fff;
        }
    }

    .bottom-text {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 1rem 0;
        font-size: 0.9rem;
        background-color: #191426;
    }
}

.logo-text {
    font-family: 'Ubuntu', sans-serif;
    font-weight: 700;
    padding-left: 25px;
    background-image: url(../assets/img/nodejobs-logo.png);
    background-repeat: no-repeat;
    background-size: 19.3px 22px;
    background-position-y: 9px;
    
    a {
        color: #fff;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
